export class Statistics {
  clientNumberTotal: number = 0;
  clientNumberSigned: number = 0;
  clientNumberNotSigned: number = 0;
  clientNumberWithAccount: number = 0;
  enterpriseNumberTotal: number = 0;
  merchantNumberTotal: number = 0;
  saleNumberTotal: number = 0;
  transactionNumberTotal: number = 0;
  caPrimeAmountTotal: number = 0;
  caPrimePercentage: number = 0;
  totalAmountToBeRefundInNextMonth: number = 0;
  totalAmountToRefund: number = 0;
  clientNumberWithNotAccountIdentified: number = 0;
  shopActive: number = 0;
  shopInactive: number = 0;
  totalAmountLimit: number = 0;
  avgAmountLimit: number = 0;
  employeeWaitingValidation: number = 0;
  depositMerchantInitiated: number = 0;
  clientNumberTotalActive: number = 0;
  totalArchivedEmployee: number = 0;
  pendingIncreasePaymentCount: number = 0;
  pendingMerchantRateChangeCount: number = 0;
  merchantRateChangeRequestCount: number = 0;
  pendingMerchantSettlementRequestCount: number = 0;
  merchantSettlementRequestCount: number = 0;
  totalAmountToBeRefundInCurrentMonth: number = 0;
  totalAmountToBeRefundInNextMonthX2: number = 0;
  totalAmountToBeRefundInNextMonthX3 : number = 0;
  totalCountToRefund : number = 0;
  totalCountToBeRefundInCurrentMonth: number = 0;
  totalCountToBeRefundInNextMonth: number = 0;
  totalCountToBeRefundInNextMonthX2: number = 0;
  totalCountToBeRefundInNextMonthX3: number = 0;
  serviceReloadAmountFailed: number = 0
  serviceReloadAmountPending: number = 0
  serviceReloadAmountProcessing: number = 0
  serviceReloadAmountSuccess: number = 0
  serviceReloadCountFailed: number = 0
  serviceReloadCountPending: number = 0
  serviceReloadCountProcessing: number = 0
  serviceReloadCountSuccess: number = 0
  pendingFundRequestCount: number = 0
  internalTransferInitiatedCount: number = 0
  company: any
  clientNumberTotalAmountLimit: any;
  clientNumberWithNotAccountIdentifiedAmountLimit: any;
  clientNumberTotalActiveAmountLimit: any;
  totalArchivedEmployeeAmountLimit: any;
}

interface Metric {
  label: string;
  value: number;
  trend: number;
  icon: string;
  color: string;
  month?: string
  count?: number
  periodKey?: string
}

interface Section {
  title: string;
  metrics: Metric[];
}

export const kpiSections: Section[] = [
  {
    title: "Performance Commerciale",
    metrics: [
      {
        label: "Transactions",
        value: 0,
        trend: 0,
        icon: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5",
        color: "bg-red-100 border border-red-200",
      },
      {
        label: "Montant total produits",
        value: 0,
        trend: 0,
        icon: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z",
        color: "bg-blue-100 border border-blue-200",
      },
      {
        label: "Remboursement total",
        value: 0,
        trend: 0,
        icon: "M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3",
        color: "bg-purple-100 border border-purple-200",
        count: 0
      },
{
        label: "Remboursement du mois en cours",
        value: 0,
        trend: 0,
        month: '',
        icon: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z",
        color: "bg-sky-100 border border-sky-100",
        count: 0,
        periodKey: 'current'

      },
      {
        label: "Remboursement du mois prochain",
        value: 0,
        trend: 0,
        month: '',
        icon: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
        color: "bg-yellow-100 border border-yellow-200",
        count: 0,
        periodKey: 'next'

      },
      {
        label: "Remboursement du mois d'après",
        value: 0,
        trend: 0,
        month: '',
        icon: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25",
        color: "bg-orange-100 border border-orange-200",
        count: 0,
        periodKey: 'nextx2'

      },
      {
        label: "Remboursement du mois d'après + 1",
        value: 0,
        trend: 0,
        month: '',
        icon: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694 4.125-8.25 4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125",
color: "bg-green-100 border border-green-200",
        count: 0,
        periodKey: 'nextx3'
      },
    ],
  },
];


export const kpiSideSections: Section[] = [
  {
    title: "Performance Commerciale",
    metrics: [
      {
        label: "CA Prime",
        value: 0,
        trend: 0,
        icon: "M2.273 5.625A4.483 4.483 0 0 1 5.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 3H5.25a3 3 0 0 0-2.977 2.625ZM2.273 8.625A4.483 4.483 0 0 1 5.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 6H5.25a3 3 0 0 0-2.977 2.625ZM5.25 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 9H5.25Z",
        color: "bg-emerald-100",
      },

      {
        label: "appel de fonds mois passé",
        value: 0,
        trend: 0,
        icon: "M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        color: "bg-red-100",
      },
      // { label: "Remboursements Clients", value: 0 , trend: 0, icon: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z", color: "bg-purple-100", },
      // { label: "Solde à compléter", value: 0, trend: 0,
      //   icon: "M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z",
      //   color: "bg-sky-100", },
    ],
  },
];
